import { auth, db } from "@shared/modules"
import { Device } from "@shared/types"

import parse from "html-react-parser"

import { getUsername, removeTokens } from "./tokens"
import {Role} from "../contexts";
import {broadcastCheckButtonTypes, CheckText} from "../components/chat/CheckButton";

function exceptionToKick(exception: Exception) {
  const { message, code } = exception

  kick(`${message}\nCODE ${code}`)
}

function kick(message?: string) {
  removeTokens()
  db().goOffline()
  auth().signOut()

  if (message) alert(message)

  window.close()
  window.location.href = "http://wownet.co.kr"
  return false
}

const HTML_ESCAPE: { [char: string]: string } = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
}

/**
 * 사용자가 입력한 특수문자를 문자 표기로 바꾼다.
 *
 * 채팅 메시지는 멘션·링크를 태그로 심은 뒤 HTML 로 파싱해서 그린다.
 * 그래서 사용자가 친 꺾쇠도 태그로 해석돼, `<http>` 처럼 영문으로 시작하면
 * 그 부분이 빈 엘리먼트가 되어 화면에서 사라진다.
 *
 * 파싱 전에 이 함수를 먼저 통과시켜야 한다. 순서가 바뀌면 우리가 심은
 * 태그까지 글자가 되어 멘션과 링크가 동작하지 않는다.
 */
function escapeHtml(text: string) {
  return text.replace(/[&<>"']/g, function (char: string) {
    return HTML_ESCAPE[char]
  })
}

function urlify(text: string) {
  var urlRegex = /(https?:\/\/[^\s]+)/g
  return parse(
    text.replace(urlRegex, function (url) {
      return `<a href="${url}" target="_blank" class="link" title="${url}">${url}</a>`
    }),
  )
}

function urlifyCustomerCenterImage(text: string) {
  var urlRegex = /(https?:\/\/[^\s]+)/g
  return parse(
    text.replace(urlRegex, function (url) {
      return `<a href="${url}" target="_blank" class="link" title="${url}"><img width=30 height=30 src="/Assets/icon_customer.png" alt="customer_center"></a>`
    }),
  )
}

function isMobile(device: string) {
  return (device as Device) === "MOBILE_WEB"
}

function getRequiredQuery(): string {
  if (process.env.NODE_ENV === "production") return ""

  return `?username=${getUsername()}`
}

function mentionTagging(text: string) {
  var mentionRegex = /(?:(^|\s))(@([^\s]+))/g

  return text.replace(
    mentionRegex,
    function (
      match: string,
      p1: string,
      p2: string,
      offset: number,
      fullText: string,
    ) {
      return `${p1}:${p2}:`
    },
  )
}

function mentionify(text: string) {
  var mentionRegex = /(?::)(@([^\s]*))(?::)/g

  return text.replace(
    mentionRegex,
    function (
      match: string,
      p1: string,
      p2: string,
      p3: string,
      offset: number,
      fullText: string,
    ) {
      return `<strong class="mention">@${p2}</strong>`
    },
  )
}

function trimAll(text: string) {
  var trimRegex = /(\s*)/g

  return text.replace(trimRegex, "")
}

const redirectLoginUrl = (scheduleId: number) => {
  try {
    const loginURL = process.env.REACT_APP_WOWMONEY_REDIRECT_URL! + scheduleId
    window.location.href = `https://login.wowtv.co.kr/sso/login?ReturnUrl=${loginURL}`
  } catch {
    window.close()
  }
}

const redirectDefaultLogin = () => {
  try {
    window.location.href = "https://login.wowtv.co.kr/sso/login?ReturnUrl=https://www.wownet.co.kr"
  } catch {
    window.close()
  }
}

const redirectSignUp = () => {
  try {
    window.location.href = "https://member.wowtv.co.kr/Join/RegistMain"
  } catch {
    window.close()
  }
}

const rand = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min

function fileConstructor(blob: Blob, filename: string) {
  try {
    return new File([blob], filename);
  } catch (error) {
    const file: any = blob;
    const date = new Date();
    file.lastModified = date.getTime();
    file.lastModifiedDate = date;
    file.name = filename;
    return file as File;
  }
}

const maskName = (name?: string, isStreamer?: boolean, role?: Role, emoji?: string) => {
  if (role === 'STREAMER' || role === 'MANAGER' || role === 'SYSTEM') return name

  // 1글자: 1글자 + *, 예시: 김 -> 김*
  // 2글자: 1글자 + *, 예시: 김철 -> 김*
  // 3글자: 1글자 + **, 예시: 김철수 -> 김**
  // 4글자 이상: 첫 두글자 + * 처리 예시: 김철수123 -> 김철****
  if (!name) return "**"
  const nameLength = name.length
  if (isStreamer) {
    if (emoji === (CheckText + broadcastCheckButtonTypes.soundUp) || emoji === (CheckText + broadcastCheckButtonTypes.soundDown) ||
      emoji === (CheckText + broadcastCheckButtonTypes.videoError) || emoji === (CheckText + broadcastCheckButtonTypes.videoNormal)) {
      return "*".repeat(nameLength)
    }
  }

  if (nameLength === 1) {
    return `${name}*`
  } else if (nameLength <= 3) {
    return `${name[0]}${"*".repeat(nameLength - 1)}`
  } else {
    return `${name.slice(0, nameLength - 3)}***`
  }
}

const isLocal = window.location.host.includes("local")
const isDev = window.location.search.includes("isDev")

function isEmptyStr(value?: string | null) {
  return !value || !value.trim()
}

export {
  isLocal,
  isDev,
  kick,
  exceptionToKick,
  escapeHtml,
  urlify,
  urlifyCustomerCenterImage,
  isMobile,
  getRequiredQuery,
  mentionTagging,
  mentionify,
  trimAll,
  redirectLoginUrl,
  redirectDefaultLogin,
  redirectSignUp,
  rand,
  fileConstructor,
  maskName,
  isEmptyStr
}

interface Exception {
  message: string
  code: number
}
